import { dateNode } from "discourse/helpers/node";
import { avatarFor as avatar } from "discourse/widgets/post";
import rawHtml from "discourse/widgets/raw-html";
import { iconNode } from "discourse-common/lib/icon-library";
export default {
  avatar,
  dateNode,
  iconNode,
  rawHtml
};